export const CUSTOM_VIEW_DATA_USER = 'customviewdatauser';
